import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class ProductivityEditService {

	private apiUrl = globalConst.baseAPI;

	constructor(private http: Http) { }

	getRegion(token) {
		

		
		
		
		
		
		

		return this.http
		.get(this.apiUrl + "/region/v1/getregion", JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

	loadProductivity(token, ID) {
		

		
		
		
		
		
		
		

		return this.http
		.get(this.apiUrl + "productivity/v1/getcodaverage/" + ID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

	editProductivity(token, prod: any) {
		console.log(prod);
		

		
		
		
		
		
		
		

		return this.http
		.put(this.apiUrl + "productivity/v1/updateaverage", JSON.stringify(prod), JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/productivity/service/productivity-edit/productivity-edit.service.ts